<template>
	<div id="app">
		<div class="header-fixed">
			<div class="header">
				<div class="logo_img" @click="logoClick">
					<div style="display:flex; align-items: center; float:left; height: 65px;">
						<div class="header-logo">
							<img id="header-img" src="../../static/home/logo.png">
						</div>
					</div>
				</div>
				<div id="menu_index">
					<!-- web端菜单导航 -->
					<ul v-if="seen" class="el-menu-demo" style="height: 65px; border:0;color:#333">
						<li class="header-title header-title-li" :class="navIndex == index ? 'active' : ''" v-for="(item, index) in navItems" :key="index" @click="handleSelect(item,index)">
							{{ item.name }}
						</li> 
					</ul>
					<!-- 手机端菜单导航 v-bind:style="{backgroundColor:'#409EFF'}" -->
					<el-menu v-if="!seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click"
						text-color="#333" style="height: 65px; border:0;" mode="horizontal"
						@select="handleSelectMobile">
						<el-submenu index="1" class="header-title mobile_menu">
							<template slot="title">{{currentMenu}}</template>
							<el-menu-item index="1" class="header-title">首页</el-menu-item>
							<el-menu-item index="2" class="header-title">在线回收</el-menu-item>
							<el-menu-item index="3" class="header-title">闲置寄存</el-menu-item>
							<el-menu-item index="4" class="header-title">商户合作</el-menu-item>
							<el-menu-item index="5" class="header-title">关于我们</el-menu-item>
							<el-menu-item index="6" class="header-title">今日金价</el-menu-item>
						</el-submenu>
					</el-menu>
				</div>
				<!-- 电话 -->
				<div class="phone">
					<img class="phone-icon" src="../../static/home/phone-icon.png" alt="" />400-0552-086
				</div>
			</div>
		</div>
		<div class="container" style="clear: both;background: #F8F8F8;">
			<router-view></router-view>
		</div>
		<div class="fixed-bottom">
			<div class="footer">
				<div class="top">
					<div class="l">
						<img class="l-img" src="../../static/home/logo-white.png" alt="" />
					</div>
					<div class="c">
						<p class="p-title">联系电话：130-3306-0125</p>
						<p class="p-t">营业执照注册地址</p>
						<p class="p-t">合肥市政务区华邦世贸中心A座</p>
					</div>
					<div class="r">
						<img class="wx-code" src="../../static/home/customer-code.png" alt="" />
						<p>客服微信</p>
					</div>
				</div>
				<div class="bottom">
					<p class="l">
						<a href="https://beian.miit.gov.cn/" target="_blank" style="color: rgb(255, 255, 255);">
							互联网ICP备案: 皖ICP备2022006755号
						</a>
					</p>
					<p>
						<a href="https://qlximg.xiaoyatou.top/certificate/yingyezhizhao.jpeg" target="_blank" style="color: rgb(255, 255, 255);">
							@yundangpu.vip 安徽趣玩网络科技有限公司版权所有
						</a>
					</p>
				</div>
			</div>
		</div>
		<div id="back_to_top" class="back_to_top" ref="btn" style="display: none;">
			<div class="back-up">
				<div @click="backTop" class="back-up-item">
					<img class="code-img" src="../../static/home/up.png" style="height: 30px;width: 26px" />
				</div>
			</div>
		</div>
		<!-- 底部 -->
		<div ref="btn1" class="loan-application" style="display: none;">
			<div class="loan">
				<div class="loan-l">
					<p>安全/高效/赋能</p>
					<p class="tel-icon"><img src="../../static/home/tel-icon.png" alt="" />130-3306-0125</p>
				</div>
				<div class="loan-c">
					<img class="loan-c-phone" src="../../static/recycle/phone-icon.png" alt="" />
					<input v-model="userPhone" class="loan-ipt" type="number" placeholder="请输入手机号" />
					<span class="btn" @click="submit">免费使用</span>
				</div>
				<div class="loan-r">
					<div class="loan-r-t">扫一扫<br />咨询更多</div>
					<img class="wx-code1" src="../../static/home/customer-code.png" alt="" />
				</div>
				<img @click="closeFun()" class="close-img" src="../../static/recycle/close.png" alt="" />
			</div>
		</div>
		<Dialog :centerDialogVisible="centerDialogVisible" @close="close"></Dialog>
	</div>
</template>

<script>
	import {
		encryptLong,
		syShopSign
	} from '@/utils/rsaEncrypt'
	import Dialog from './Dialog.vue'
	export default {
		name: "Layout",
		components: {Dialog},
		data() {
			return {
				activeIndex: '1',
				company: {
					qrcode: require("../../static/other/yundangpu.png"),
				},
				scroll: '',
				timer: '',
				seen: true,
				currentMenu: '首页',
				userPhone: '',
				centerDialogVisible: false,
				navIndex: 0,
				navItems: [
					{name: '首页', to: '/'},
					{name: '灵活回收', to: '/recycle'},
					{name: '定价购买', to: '/deposit'},
					{name: '商户合作', to: '/cooperate'},
					{name: '关于我们', to: '/aboutUs'},
					{name: '今日金价', to: '/gold'},
				]
			};
		},
		methods: {
			close(flag) {
				this.centerDialogVisible = flag
			},
			handleScroll() {
				this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
				let btn = document.querySelector('#back_to_top')
				let btn1 = document.querySelector('.loan-application')
				if (this.scroll > 600) { 
					btn.style.display = 'block'
					btn1.style.display = 'block'
				} else {
					btn.style.display = 'none'
					btn1.style.display = 'none'
				}
			},
			closeFun() {
				this.$refs.btn1.style.display = 'none'
			},
			submit() {
				if (this.userPhone == '') {
					this.$message.error('请输入手机号');
					return false
				}
				let res = this.util.request({
					url: `/sy/getYunPuWebsite/submitFrom`,
					method: 'POST',
					data: {
						userPhone: this.userPhone,
						clueType: 0,
					},
				}).then(res => {
					if (res.status === 200) {
						this.centerDialogVisible = true
						this.userPhone = ''
					}
				}).catch(error => {
					this.$message.error(error);
				});
			},
			getOpenMinChengXuLink() {
				if (this.isMobile()) {
					let url = '/sy/aboutUs/getScheme';
					const timeStamp = new Date().getTime();
					const sySign = syShopSign();
					const CheckCsrf = encryptLong(sySign + timeStamp);
					this.axios.get(url, {
						headers: {
							'TimeStamp': timeStamp,
							'CheckCsrf': CheckCsrf,
							'Content-Type': 'application/x-www-form-urlencoded'
						}
					}).then(res => {
						location.href = res.data.data;
					})
				} else {
					console.log('pc端不跳转')
					return;
				}

			},
			// 判断是否是手机端，如果是，返回true
			isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
					)
				return flag
			},
			handleSelect(item, key) {
				this.navIndex = key
				this.$router.push({
					path: item.to
				})
			},
			handleSelectMobile(key) {
				switch (key) {
					case '1':
						this.$router.push({
							name: "Index"
						});
						this.currentMenu = '首页';
						break;
					case '3':
						this.$router.push({
							name: "Index"
						});
						window.location.hash = "#寄存回收";
						this.currentMenu = '首页';
						break;
					case '4':
						this.$router.push({
							name: "Index"
						});
						window.location.hash = "#延期买回";
						this.currentMenu = '首页';
						break;
					case '5':
						this.$router.push({
							name: "Index"
						});
						window.location.hash = "#关于我们";
						this.currentMenu = '首页';
						break;
				}
			},
			backTop() { //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
				this.timer = setInterval(() => {
					let osTop = document.documentElement.scrollTop || document.body.scrollTop;
					let ispeed = Math.floor(-osTop / 5)
					document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
					if (osTop === 0) {
						clearInterval(this.timer)
					}
				}, 30)
			},
			menuSeen() {
				// 屏幕尺寸
				let screenHeight = document.body.clientWidth;
				if (screenHeight > 415) {
					this.seen = true;
				} else {
					this.seen = false;
				}
			},
			logoClick() {
				if (this.isMobile()) {
					let url = '/sy/aboutUs/getScheme';
					const timeStamp = new Date().getTime();
					const sySign = syShopSign();
					const CheckCsrf = encryptLong(sySign + timeStamp);
					this.axios.get(url, {
						headers: {
							'TimeStamp': timeStamp,
							'CheckCsrf': CheckCsrf,
							'Content-Type': 'application/x-www-form-urlencoded'
						}
					}).then(res => {
						location.href = res.data.data;
					})
				} else {
					location.reload();
				}

			}
		},
		mounted() {
			this.menuSeen()
			window.addEventListener('scroll', this.handleScroll)
		},
	}
</script>

<style scoped>
	.container {
		margin-top: 65px;
	}

	.el-menu-item.is-active {
		color: #FE3D3A !important;
		border-bottom: transparent !important;
	}

	.xiaochengxu {
		position: absolute;
		margin-right: 10%;
	}
	
	.active {
		color: #FE3D3A !important;
	}
	
	.header-fixed {
		justify-content: flex-end;
		display: flex;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		background-color: #fff;
		z-index: 999;
		padding: 3px 0;
		box-shadow: 0px 5px 15px 0px rgba(230, 230, 230, 0.5);
	}

	.logo_img {
		cursor: pointer;
	}

	#back_to_top {
		position: fixed;
		bottom: 150px;
		right: 30px;
		cursor: pointer
	}

	.header-title {
		font-weight: 600;
		font-size: 1.2rem;
		color: #333333;
	}
	
	.header-title-li {
		padding: 0 20px;
		cursor: pointer;
	}

	.company_name {
		font-weight: normal;
		font-size: 1rem;
	}

	.footer_font {
		font-size: 1rem;
	}

	#menu_index {
		flex: 1;
	}
	
	.el-menu-demo {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	
	.phone {
		font-weight: 600;
		font-size: 16px;
		color: #FE3D3A;
		display: flex;
		align-items: center;
		margin-left: 40px;
	}
	
	.phone-icon {
		width: 20px;
		height: 20px;
		margin-right: 5px;
	}

	.header {
		margin: auto;
		width: 1200px;
		height: 65px;
		display: flex;
		align-items: center;
	}

	@media screen and (max-device-width: 415px) {
		.logo_img {
			float: left;
			width: auto;
			cursor: pointer;
		}

		#back_to_top {
			position: fixed;
			bottom: 50px;
			right: 5px;
			cursor: pointer
		}

		.footer_font {
			font-size: 0.875rem;
		}

		#menu_index {
			float: right;
			width: auto;
			height: 100%
		}

		.mobile_menu {}
	}

	#header-img {
		width: 80px;
		height: 50px;
		float: left;
		margin: auto;
	}

	.header-logo {
		height: 50px;
		width: 80px;
		align-self: center;
	}

	.header-important {
		float: left;
		margin-left: 6px;
		align-self: center;
	}

	a {
		text-decoration: none;
	}

	a:visited {
		text-decoration: none;
	}

	a:hover {
		text-decoration: none;
	}

	a:active {
		text-decoration: none;
	}
	.fixed-bottom {
		background: #333333;
	}
	.fixed-bottom .footer {
		width: 1200px;
		margin: 0 auto;
		padding-top: 40px;
		padding-bottom: 30px;
	}
	.footer .top {
		display: flex;
		color: #fff;
		padding-bottom: 20px;
		border-bottom: 1px solid #686868;
	}
	.l-img {
		width: 80px;
		height: 50px;
		margin-right: 80px;
	}
	.footer .top .c {
		flex: 1;
	}
	.p-title {
		font-weight: 600;
		font-size: 20px;
		color: #FFFFFF;
		margin: 0;
		margin-bottom: 20px;
	}
	.p-t {
		font-size: 14px;
		color: #999999;
		margin: 0;
		margin-bottom: 10px;
	}
	.footer .top .r {
		text-align: center;
	}
	.wx-code {
		width: 100px;
		height: 100px;
	}
	.footer .bottom {
		display: flex;
		align-items: center;
	}
	.footer .bottom p {
		margin: 0;
		padding-top: 30px;
	}
	.footer .bottom .l {
		flex: 1;
	}
	.footer .bottom a {
		font-size: 14px;
		color: #999999 !important;
	}
	/* 底部 */
	.loan-application {
		padding: 12px 0;
		background: rgba(0, 0, 0, .5);
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 100;
		.loan {
			width: 1200px;
			margin: 0 auto;
			font-weight: 600;
			font-size: 16px;
			color: #FFFFFF;
			display: flex;
			align-items: center;
		}
		.loan-l,.loan-c,.loan-r {
			flex: 1;
		}
		.tel-icon {
			display: flex;
			align-items: center;
		}
		.loan-c {
			width: 400px;
			height: 50px;
			line-height: 50px;
			background: #FFFFFF;
			border-radius: 8px;
			border: 1px solid #FFFFFF;
			display: flex;
			align-items: center;
			padding-left: 10px;
			.loan-ipt {
				flex: 1;
				padding-left: 10px;
				padding-right: 10px;
			}
			.btn {
				display: inline-block;
				width: 142px;
				height: 50px;
				background: #FE3D3A;
				border-radius: 8px;
				text-align: center;
				font-size: 14px;
				cursor: pointer;
			}
		}
		.loan-c-phone {
			width: 22px;
			height: 22px;
		}
		.loan-r {
			text-align: right;
			display: flex;
			justify-content: flex-end;
		}
		.close-img {
			position: fixed;
			right: 20px; 
			bottom: 70px;
			width: 20px;
			height: 20px;
		}
		.loan-r-t {
			margin-top: 15px;
		}
	}
	.wx-code1 {
		width: 80px;
		height: 80px;
		margin-left: 5px;
	}
	.back-up-item {
		width: 50px;
		height: 50px;
		background: #FFFFFF;
		box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.1);
		border-radius: 7px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 2px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Layout.vue